import { createResponsiveStyles, theme } from "@clearabee/ui-library-native";
import { Platform, ViewStyle } from "react-native";
import ResponsiveStylesheet from "react-native-media-query";

export const { styles, ids } = ResponsiveStylesheet.create({
  nextWrap: createResponsiveStyles({
    base: {
      justifyContent: "space-between",
      marginTop: theme.spacing.medium,
      alignItems: "center",
    },
    small: {
      flexDirection: "row",
    },
    medium: {
      marginTop: "auto",
      marginLeft: "auto",
    },
  }),
  searchError: {
    marginTop: theme.spacing.xlarge,
    marginHorizontal: "auto",
    backgroundColor: theme.colors.negative.base,
  },
  description: createResponsiveStyles({
    base: {
      marginRight: theme.spacing.small,
      marginBottom: theme.spacing.small,
    },
    small: {
      marginBottom: 0,
    },
  }),
  nextButton: {
    width: 140,
    boxSizing: Platform.OS === "web" ? "border-box" : undefined, // fixes sizing issue with native button
  } as ViewStyle,
});
